<template>
  <i
    class="bi bi-arrows-angle-expand tinytxt text-success float-end"
    v-if="!stats"
    @click="toggleEdit()"
  ></i>
  <ul class="list-group" v-if="!edit_data" @click="toggleEdit()">
    <li class="list-group-item text-muted tinylist" v-for="s in stats" :key="s">
      <div class="row">
        <div class="col">
          {{ s }}
        </div>
      </div>
    </li>
  </ul>
  <div v-if="edit_data">
    <div class="row">
      <div class="col">
        <button class="btn btn-success tinytxt" @click="updateStats()">
          Update
        </button>
      </div>
      <div class="col">
        <button class="btn btn-danger tinytxt" @click="toggleEdit()">
          Cancel
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <input
          type="text"
          class="form-control tinytxt"
          v-model.trim="value_0"
          @keyup.enter="updateStats()"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <input
          type="text"
          class="form-control tinytxt"
          v-model.trim="value_1"
          @keyup.enter="updateStats()"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <input
          type="text"
          class="form-control tinytxt"
          v-model.trim="value_2"
          @keyup.enter="updateStats()"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <input
          type="text"
          class="form-control tinytxt"
          v-model.trim="value_3"
          @keyup.enter="updateStats()"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <input
          type="text"
          class="form-control tinytxt"
          v-model.trim="value_4"
          @keyup.enter="updateStats()"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <input
          type="text"
          class="form-control tinytxt"
          v-model.trim="value_5"
          @keyup.enter="updateStats()"
        />
      </div>
    </div>
  </div>
</template>
<script setup>
import { defineProps, defineEmits, ref, onMounted } from "vue";
const props = defineProps(["stats", "player_id"]);
import supabase from "@/supabase/config";
const emit = defineEmits(["statsUpdated"]);
const stats = ref([]);

const player_id = ref("");
const edit_data = ref(false);
const value_0 = ref("");
const value_1 = ref("");
const value_2 = ref("");
const value_3 = ref("");
const value_4 = ref("");
const value_5 = ref("");

const toggleEdit = () => {
  edit_data.value = !edit_data.value;
  if (edit_data.value) {
    populateValues();
  }
};
const populateValues = () => {
  if (stats.value) {
    if (stats.value[0]) {
      value_0.value = stats.value[0];
    }
    if (stats.value[1]) {
      value_1.value = stats.value[1];
    }
    if (stats.value[2]) {
      value_2.value = stats.value[2];
    }
    if (stats.value[3]) {
      value_3.value = stats.value[3];
    }
    if (stats.value[4]) {
      value_4.value = stats.value[4];
    }
    if (stats.value[5]) {
      value_5.value = stats.value[5];
    }
  }
};
onMounted(() => {
  stats.value = props.stats;
  player_id.value = props.player_id;
});
const updateStats = async () => {
  var temp_data = [];
  if (value_0.value) {
    temp_data.push(value_0.value);
  }
  if (value_1.value) {
    temp_data.push(value_1.value);
  }
  if (value_2.value) {
    temp_data.push(value_2.value);
  }
  if (value_3.value) {
    temp_data.push(value_3.value);
  }
  if (value_4.value) {
    temp_data.push(value_4.value);
  }
  if (value_5.value) {
    temp_data.push(value_5.value);
  }
  //console.log(temp_data);

  const { data, error } = await supabase
    .from("players")
    .update({ stats: temp_data })
    .eq("id", props.player_id)
    .select();
  if (!error) {
    emit("statsUpdated");
  }
};
</script>
<style scoped>
.tinylist {
  padding: 0px;
  font-size: 8px;
}
.zeropadding {
  padding: 0px;
}
.tinytxt {
  font-size: 8px;
  padding: 3px;
}
</style>
